import { useCallback, useState } from 'react';
import { useSelfContext } from '@/context';
import { ReserveHttp } from '@/services';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

export default function useReserveVotables() {

  const [t] = useTranslation(['common', 'reserve']);
  const [loading, setLoading] = useState(true);
  const { findTypeById, currentSelf } = useSelfContext();
  const [votables, setVotables] = useState<ReserveVotableEntity[]>([]);
  const [rateReasons, setRateReasons] = useState<VoteRatingReasonEntity[]>([]);
  const [isFetched, setIsFetched] = useState(false);

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      await Promise.all([
        ReserveHttp.listVoteReasons().then(res => {
          setRateReasons(res.payload ?? []);
        }),
        ReserveHttp.listVotable().then(res => {
          setVotables(res.payload ?? []);
        })
      ]);
      setIsFetched(true);
    }
    catch (e) {
    }
    finally {
      setLoading(false);
    }
  }, [setLoading, setVotables, setRateReasons]);

  const submit = useCallback(async (id: number, payload: CreateReserveVoteEntity) => {
    await ReserveHttp.vote(id, payload);
    message.success({ content: t('reserve:messages.success-comment-submit') });
    setVotables(items => items.filter(x => x.id !== id));
  }, [setVotables, t]);

  const votableItems = votables.filter(v => findTypeById(v.program.self.id) === currentSelf?.type);

  return { fetch, submit, isFetched, loading, votableItems, rateReasons };
}
